import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import SwipeableTextMobileStepper from "./MobileStepper";

import { SecondaryStyle } from "../fonts";

import Carousel2Image1 from "../assets/Page5R1.webp";
import Carousel2Image2 from "../assets/Page5R2.webp";
import Carousel1Image1 from "../assets/Page5LC1.webp";
import Carousel1Image2 from "../assets/Page5LC2.webp";
import Carousel1Image3 from "../assets/Page5LC3.webp";
import LA from "../assets/Page5LA.webp";
//@ts-ignore
import LB from "../assets/Page5LB.mp4";

const carousel1Images = [Carousel1Image1, Carousel1Image2, Carousel1Image3];
const carousel2Images = [Carousel2Image1, Carousel2Image2];

const Page5 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: { xs: "100%", sm: "100vh" },
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* 1st half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: {
                      xs: "45vh",
                      sm: "100%",
                    },
                  }}
                >
                  {/* RD */}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderTop: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: ".5vh solid #fff",
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      backgroundImage: `url('${LA}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                </Grid>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: { xs: "81.5vh", sm: "100%" },
                  }}
                >
                  {/**RC */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: ".5vh solid #fff",
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      height: {
                        xs: "36vh",
                        sm: "100%",
                      },
                    }}
                  >
                    <SwipeableTextMobileStepper
                      images={carousel1Images}
                      autoplay={false}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: ".5vh solid #fff",
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },

                      height: { xs: "45.5vh", sm: "50vh" },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: { xs: "45vh", sm: "50vh" },
                        objectFit: "cover",
                      }}
                      src={LB}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* 2nd Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={9}>
                <Grid
                  container
                  direction={"row"}
                  sx={{ height: { xs: "35vh", sm: "100%" } }}
                >
                  {/* LD/LA/*/}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: ".1vh solid #fff",
                      },
                      borderTop: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                    }}
                  >
                    <SwipeableTextMobileStepper images={carousel2Images} />
                  </Grid>
                </Grid>

                {/* LB */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    pb: { xs: 1.5 },
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      ...SecondaryStyle,
                      textAlign: "justify",
                      "@media (orientation: landscape)": {
                        fontSize: { xs: "1vw", md: "1vw", lg: "1vw" },
                        lineHeight: { xs: "1.1vw", md: "1.1vw", lg: "1.1vw" },
                        paddingTop: "2vw",

                        px: { xs: "2vh", sm: "2vw" },
                      },
                      "@media (orientation: portrait)": {
                        fontSize: {
                          xs: "1.7vh",
                          sm: "1vh",
                        },
                        lineHeight: {
                          xs: "2vh",
                          sm: "1.65vh",
                          md: "1.5vh",
                          lg: "1.8vh",
                        },
                        paddingTop: {
                          xs: "1vh",
                          sm: "2.2vh",
                          md: "1.2vh",
                          lg: "0vh",
                        },
                        px: { xs: "1.5vh", sm: "2vw" },
                      },
                    }}
                  >
                    The basement of this home offers a versatile and inviting
                    space, perfect for a variety of needs. The spacious rec room
                    is ideal for family gatherings or quiet nights in, while the
                    office nook provides a dedicated area for work or study. The
                    laundry room is both functional and stylish, featuring
                    generous storage and ample folding space, making household
                    chores a breeze. A convenient 3-piece bath completes this
                    lower level, adding to the home's thoughtful design and
                    ensuring functionality throughout.
                  </Typography>
                </Grid>
              </Grid>
              {/* LC/LB */}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page5;
